<template>
  <asc-dialog
    text="Notice"
    primary-button-text="Continue"
    secondary-button-text="Cancel"
    :show-dialog="showDialog"
    :on-close="handleClose"
    :on-primary="handleAccept"
    :on-secondary="handleCancel"
    :primary-available="isCurrentDataValid"
    :width="450"
    full-width-buttons
  >
    <template v-if="showDialog">
      <asc-global-filter-confirmation
        v-model="currentData"
        :on-update="handleUpdate"
      ></asc-global-filter-confirmation>
    </template>
  </asc-dialog>
</template>

<script>
import { AscDialogMixin } from '@/components/mixins'
import AscDialog from '@/components/atoms/AscDialog'
import AscGlobalFilterConfirmation from './AscGlobalFilterConfirmation'

export default {
  name: 'AscGlobalFilterConfirmationDialog',

  components: {
    AscDialog,
    AscGlobalFilterConfirmation,
  },

  mixins: [AscDialogMixin],

  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },

  data() {
    return {
      currentData: false,
    }
  },

  computed: {
    isCurrentDataValid() {
      return true
    },
  },

  methods: {
    handleAccept() {
      this.onAccept(this.currentData)
      this.handleClose()
    },

    handleUpdate(status) {
      this.currentData = status
    },

    handleCancel() {
      if (this.onCancel) {
        this.onCancel()
      }
    },
  },
}
</script>
